import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import useFilter from '@hooks/useFilter';

import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';

const Color = ({ filterPageName }) => {
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const { data = [], handleSearch } = useFilter(filterPageName, dependentFilterList?.colorList);
	const [currentPath, setCurrentPath] = useState('');
	const location = useLocation();

	useEffect(() => {
		const path = location.pathname;
		setCurrentPath(path);
	}, []);

	const colorsList = data.map((color) => ({
		...color,
		id: currentPath !== '/assets' ? color?.name : color?.id
	}));

	return (
		<>
			<FilterName type="COLOR" />
			<Checkbox data={colorsList} type="COLOR" handleSearch={handleSearch} />
		</>
	);
};

export default Color;
